import fetchExpresso from 'utility/fetchExpresso';

export async function deleteReportView(eventId: number, viewId: number): Promise<void> {
    const res = await fetchExpresso(`/apiv2/events/${eventId}/report-views/${viewId}`, {
        method: 'DELETE',
    });

    if (!res.ok) {
        const error = (await res.json().catch(() => null)) as { message?: string } | null;
        throw new Error(error?.message || 'Failed to delete report view');
    }
}
